import type { UTCStorageRecord } from "@multisystemsuite/timezone-engine-shared-types";
import { getUtcOffset, toUTC } from "./conversion.js";
import { safeTimezoneFallback } from "./validation.js";

function toDate(input: Date | string | number): Date {
  if (input instanceof Date) return input;
  return new Date(input);
}

/** Normalize and persist timestamps in UTC with source timezone metadata */
export function ensureUTCStorage(
  date: Date | string | number,
  sourceTimezone: string,
): UTCStorageRecord {
  const tz = safeTimezoneFallback(sourceTimezone);
  const d = toUTC(toDate(date), tz);
  return {
    utc: d.toISOString(),
    sourceTimezone: tz,
    originalOffset: getUtcOffset(tz, d),
    storedAt: new Date().toISOString(),
  };
}

/** Rehydrate a UTC storage record to a Date instance */
export function parseUTCStorage(record: UTCStorageRecord): Date {
  return new Date(record.utc);
}
